import React from 'react';

const Blog = () => {
	return (
		<div>
			<div className='bg-dark vh-100 text-white'>
				<h1 className='text-decoration-underline fw-bold pt-5 text-center '>
					<span className='text-info'></span> Comming-Soon
				</h1>
				<hr />
			</div>
		</div>
	);
};

export default Blog;
